import { AxiosRequestConfig } from 'axios';
import { Cart, ValidatedCart, CartProperties } from '../domain/cart';
import { apiClient } from './client';
import { withAuthorizationHeader } from './auth';

export type AddToCartPayload = {
  action: 'ADD' | 'DELETE' | 'UPDATE';
  data: {
    marketId: string;
    productId: string;
    variantId: string;
    quantity: number;
    cooperativeId: string;
    sellingUnitId?: string;
  };
};

export const addToCart = async (
  token: string,
  payload: AddToCartPayload,
  opts: AxiosRequestConfig = {},
): Promise<Cart> => {
  const response = await apiClient.post<Cart>(
    '/v1/carts',
    payload,
    withAuthorizationHeader(token, opts),
  );
  return response.data;
};

export const updateCartProperties = async (
  token: string,
  marketId: string,
  properties: CartProperties,
  opts: AxiosRequestConfig = {},
): Promise<Cart> => {
  const response = await apiClient.patch<Cart>(
    `/v1/carts/${marketId}/properties`,
    properties,
    withAuthorizationHeader(token, opts),
  );
  return response.data;
};

export const getCart = async (
  token: string,
  marketId: string,
  opts: AxiosRequestConfig = {},
): Promise<ValidatedCart> => {
  const response = await apiClient.get<ValidatedCart>(
    `/v1/market/${marketId}/cart`,
    withAuthorizationHeader(token, opts),
  );
  return response.data;
};
